export default __webpack_public_path__ + "static/02-02-teach-feedback-589cb596d06116da7930d10917fa0e7c.mp4";